
const theme = {
  colors: {
    dark: {
      main: "#242731",
      mainLight: "#2a3147ab",
      primary: "#6C5DD3",
      secondary: "#F4F4FA",
      primaryLight: "#6C5DD30A"
    }
  },
  offset: {
    sm: 50,
    md: 100
  },
  gap: {
    sm: 12,
    md: 24,
    lg: 36
  },
  radius: {
    sm: 12
  },
  screen: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: 1440
  }
}

export default theme;
